//Built-in import

import * as React from "react";

import { Box } from "@mui/material";
import ChatboxInputButtonAttach from "./attach";
import ChatboxInputButtonText from "./text";
import { useUploader } from "@/hook";

//External import


//Internal import



interface IChatboxInputButtonProps {
  removeAttach?: boolean
  text: string;
  addMessage: Function;
  handleChangeFile: (file: File) => void;
}

const ChatboxInputButton: React.FunctionComponent<IChatboxInputButtonProps> = ({
  removeAttach,
  text,
  addMessage,
  handleChangeFile,
}) => {
  const { file, hiddenInput, hasFile, fileRemover } = useUploader();
  React.useEffect(() => {
    handleChangeFile(file as File);
  }, [file]);

  React.useEffect(()=>{
    fileRemover()
  },[removeAttach])

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        right: 8,
        transform: "translateY(-50%)",
      }}
    >
      {!hasFile &&
        <ChatboxInputButtonAttach
          fileRemover={fileRemover}
          hasFile={hasFile}
          hiddenInput={hiddenInput}
        />
      }
      <ChatboxInputButtonText addMessage={addMessage} />
    </Box>
  );
};

export default React.memo(ChatboxInputButton);
